module.exports = __webpack_public_path__ + "img/sta_unopened.e4c947e6.png";